import proptypes from 'prop-types';

const { bool, string } = proptypes;

export const propTypes = {
  curationId: string.isRequired,
  preview: bool
};

export const defaultProps = {
  preview: false
};
